import React from 'react';
import styles from '../../ChargebackProtection.module.css';
import { CheckIcon } from '../../icons';

const FeatureBlocks = () => (
  <>
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={styles.feature}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Hands-off</span>
            <h2>We handle the dispute response.</h2>
            <p>Fighting a chargeback usually means digging up receipts and deadlines under pressure. With Fyntiq, eligible fraud claims are responded to on your behalf — evidence gathered, paperwork filed, deadlines met.</p>
            <ul className={styles.fList}>
              {['Evidence compiled automatically', 'Responses filed before the deadline', 'Track every dispute in your dashboard', 'Keep the revenue on covered claims'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop} style={{ border: 'none', paddingBottom: 6 }}>
              <div className={styles.invNum} style={{ fontSize: 14 }}>Recent disputes</div>
              <span className={styles.invLab}>HANDLED BY FYNTIQ</span>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOn}`} />
              <div className={styles.recFlex}><div className={styles.recName}>#DSP-2208 · Fraud</div><div className={`${styles.recMeta} ${styles.recMetaGreen}`}>Covered · $420</div></div>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOn}`} />
              <div className={styles.recFlex}><div className={styles.recName}>#DSP-2199 · Fraud</div><div className={`${styles.recMeta} ${styles.recMetaGreen}`}>Covered · $89</div></div>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOff}`} />
              <div className={styles.recFlex}><div className={styles.recName}>#DSP-2201 · Response filed</div><div className={styles.recMeta}>In review</div></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={`${styles.feature} ${styles.featureFlip}`}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Prevention first</span>
            <h2>Real-time fraud screening.</h2>
            <p>The best dispute is the one that never happens. Every transaction is screened for fraud signals as it comes in, so risky payments get flagged before they cost you the goods and the sale.</p>
            <ul className={styles.fList}>
              {['Real-time screening on every payment', 'Risky transactions flagged early', 'Fewer disputes to deal with in the first place', 'Protection that works in the background'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop}>
              <div><div className={styles.invLab}>SCREENING</div><div className={styles.invNum}>Payment · $1,240.00</div></div>
              <span className={styles.invStatus} style={{ background: 'var(--green-soft)', color: 'var(--green)' }}>Low risk</span>
            </div>
            <div className={styles.invRow}><span>Device &amp; location</span><span className={`${styles.mono} ${styles.monoGreen}`}>✓ Match</span></div>
            <div className={styles.invRow}><span>Velocity check</span><span className={`${styles.mono} ${styles.monoGreen}`}>✓ Pass</span></div>
            <div className={styles.invRow}><span>Risk score</span><span className={styles.mono}>7 / 100</span></div>
            <div className={styles.invPaynow} style={{ background: 'var(--green)' }}>Cleared to process ✓</div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default FeatureBlocks;
